module.exports = __webpack_public_path__ + "img/loss-icon.89cb5586.svg";